export default __webpack_public_path__ + "static/cmore-back-15340c48d5ddae54ba1809ecaa166163.webp";